module.exports = __webpack_public_path__ + "img/plus.98d8f3e7.svg";